import styled, { css } from "styled-components"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"
import media from "src/styles/media"

export const ContactWrapper = styled(BackgroundImage)`
  background-size: cover;
  background-position: top;

  ${media.lessThan("md")`
        &, &:before{
            background-image: none !important;
            background-size: 10px;
        }
    `}
`

export const ContactContent = styled.div`
  padding: 180px 0 80px 0;

  ${media.lessThan("md")`
        background-color: var(--dark) !important;
        padding-top: 20px;
        padding-bottom: 40px;
    `}

  @media screen and (min-width: 1700px) {
    padding-top: 250px;
  }
`

export const ContactCaption = styled.header`
  padding-left: 50px;

  ${props =>
    props.variant === "sm" &&
    css`
      padding-left: 35%;

      ${media.lessThan("xl")`
            padding-left: 25%;
         `}
    `}

  ${media.lessThan("lg")`
         display: flex;
         flex-direction: column;
         align-items: center;
         text-align: center;
         padding-left: 0;
    `}
`

export const ContactTitle = styled.h2`
  font-size: 56px;
  max-width: 350px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 10px;
  color: #fff;

  ${media.lessThan("md")`
         font-size: 46px;
         max-width: 280px;

         ${props =>
           props.variant === "sm" &&
           css`
             padding-top: 20px;
           `}
    `}
`

export const ContactParagraph = styled.p`
  font-size: 24px;
  max-width: 370px;
  font-weight: 300;
  line-height: 1.2;
  margin-bottom: 30px;
  color: #fff;

  ${media.lessThan("md")`
         font-size: 17px;
         max-width: 280px;
         margin-bottom: 15px;

         ${props =>
           props.variant === "sm" &&
           css`
             padding-top: 20px;
           `}
    `}
`

export const ContactButton = styled.a`
  display: block;
  margin-bottom: 40px;
  margin-top: 20px;

  button {
    padding: 7px 22px;
  }
`

export const ContactSubTitle = styled.h3`
  font-weight: 300;
  font-size: 28px;
  margin-bottom: 0px;
  color: #fff;
`

export const ContactMethods = styled.div`
  margin-bottom: 15px;

  @media screen and (max-width: 768px) {
    margin-top: 5px;
  }
`

export const ContactLink = styled.a`
  font-weight: 300;
  font-size: 18px;
  display: block;
  color: #fff;
  transition: all 0.3s;

  @media screen and (max-width: 769px) {
    padding: 6px 0;
  }

  &:hover {
    color: #fff;
  }
`

export const ContactSocial = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin-top: 7px;
`

export const ContactSocialLink = styled.a`
  display: block;
  position: relative;
  width: 40px;
  height: 40px;
  border: 1px solid #fff;
  border-radius: 50%;
  transition: all 0.4s;
  margin-right: 10px;

  ${media.lessThan("md")`
        width: 35px;
        height: 35px;
        margin-right: 15px;
    `}

  &:hover {
    transform: rotate(360deg) scale(1.1);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
    color: #fff;
  }
`

export const CurveTop = styled(Img)`
  position: absolute;
  top: 2px;
  left: -5%;
  width: 110%;
  z-index: 3;
  display: none;

  ${media.lessThan("md")`
        display: block;
    `}
`
